import { clevertapEvent } from 'utils/clevertap';
import {
  GROUP_CHAT_ACTIONS,
  GROUP_CHAT_MEMBER_TYPE,
  GROUP_CHAT_INFO_SETTINGS_ACTIONS,
} from './constants';

/**
 * doc link: https://www.notion.so/stockbit/Group-Chat-Web-aa5727bc81934c748b5663c84b80f9cb#bc428199b1e041a3b386c70989325540
 */
export const createNewGroupChatNavigate = {
  onGroupChatAddMemberViewed: () => {
    clevertapEvent('Group Chat Add Member Viewed');
  },
  onNewGroupChatViewed: () => {
    clevertapEvent('Group Chat New Group Viewed');
  },
  onChangeGroupChatPhotoViewed: () => {
    clevertapEvent('Group Chat Change Group Photo Viewed');
  },
  onEditGroupChatPhotoViewed: () => {
    clevertapEvent('Group Chat Edit Group Photo Viewed');
  },
};

export const groupChatInfoSettings = {
  onGroupChatRoomViewed: (
    source, // see enum GROUP_CHAT_SOURCES
    isMessageRequest = false,
    roomId = 0,
  ) => {
    clevertapEvent('Group Chat Room Viewed', {
      Source: source,
      'Is Message Request': isMessageRequest,
      'Message ID': roomId,
    });
  },
  onGroupChatMoreBottomSheetViewed: () => {
    clevertapEvent('Group Chat More bottom sheet Viewed');
  },
  onGroupChatInfoViewed: () => {
    clevertapEvent('Group Info Viewed');
  },
  onGroupChatEditGroupInfoViewed: () => {
    clevertapEvent('Group Chat Edit Group Info Viewed');
  },
  onGroupChatEditAvatarViewed: () => {
    clevertapEvent('Group Chat Edit Avatar Viewed');
  },
  onGroupChatAvatarViewed: () => {
    clevertapEvent('Group Chat Avatar Viewed');
  },
  onGroupChatRemoveGroupPhotoViewed: () => {
    clevertapEvent('Group Chat Remove Group Photo Viewed');
  },
  onGroupChatAddMemberViewed: () => {
    clevertapEvent('Group Chat Add Member Viewed');
  },
  onGroupChatInviteViaLinkViewed: () => {
    clevertapEvent('Group Chat Invite via Link Viewed');
  },
  onGroupChatInviteViaStockbitViewed: () => {
    clevertapEvent('Group Chat Invite via Stockbit Viewed');
  },
  onGroupChatConfirmationResetLinkViewed: () => {
    clevertapEvent('Group Chat Confirmation Reset Link Viewed');
  },
  onGroupChatConfirmationLeaveGroupViewed: () => {
    clevertapEvent('Group Chat Confirmation Leave Group Viewed');
  },
  onGroupChatConfirmationChooseNewAdminViewed: () => {
    clevertapEvent('Group Chat Confirmation Choose New Admin Viewed');
  },
  onGroupChatSetNewAdminViewed: () => {
    clevertapEvent('Group Chat Set New Admin Viewed');
  },
  onGroupChatMemberInfoViewed: () => {
    clevertapEvent('Group Chat Member Info Viewed');
  },
  onGroupChatAddTipViewed: () => {
    clevertapEvent('Group Chat Add Tip Viewed');
  },
  onGroupChatConfirmationAssignAdminViewed: () => {
    clevertapEvent('Group Chat Confirmation Assign Admin Viewed');
  },
  onGroupChatConfirmationRemoveMemberViewed: () => {
    clevertapEvent('Group Chat Confirmation Remove Member Viewed');
  },
  onGroupChatConfirmationChatRoleAdminRemoveViewed: () => {
    clevertapEvent('Group Chat Role Admin Removed Viewed');
  },
  onGroupChatConfirmationJoinGroupViewed: () => {
    clevertapEvent('Group Chat Confirmation Join Group Viewed');
  },
  onGroupChatLinkFromOtherPlatformOpened: () => {
    clevertapEvent('Group Link From Other Platform Opened');
  },
  onGroupChatLinkNotFoundViewed: () => {
    clevertapEvent('Group Link Not Found Viewed');
  },
};

export const createNewGroupChatAction = {
  onGroupChatCreateNewGroupClicked: (
    action = GROUP_CHAT_ACTIONS.createNewGroup,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatSearchContactFilled: (
    action = GROUP_CHAT_ACTIONS.searchContactFilled,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatCreateNewGroupNextClicked: (
    action = GROUP_CHAT_ACTIONS.createNewGroupNextFilled,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatAddGroupPhotoSelected: (
    action = GROUP_CHAT_ACTIONS.addGroupPhotoSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatGroupNameFilled: (action = GROUP_CHAT_ACTIONS.groupNameFilled) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatGroupDescriptionFilled: (
    action = GROUP_CHAT_ACTIONS.groupDescriptionFilled,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatCreateClicked: (action = GROUP_CHAT_ACTIONS.createClicked) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatUploadImageSelected: (
    action = GROUP_CHAT_ACTIONS.uploadImageSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatRemovePhotoSelected: (
    action = GROUP_CHAT_ACTIONS.removePhotoSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatRequestAcceptSelected: (
    action = GROUP_CHAT_ACTIONS.requestGroupChatAcceptSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatRequestLeaveSelected: (
    action = GROUP_CHAT_ACTIONS.requestGroupChatLeaveSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
};

export const groupInfoSettingsAction = {
  onGroupChatMoreSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.moreSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatGroupInfoSelected: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.groupInfoSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
    });
  },
  onGroupChatMuteNotificationsSelected: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    source, // see enum GROUP_CHAT_SOURCES
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.muteNotificationsSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
      Source: source,
    });
  },
  onGroupChatUnMuteNotificationSelected: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    source, // see enum GROUP_CHAT_SOURCES
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.unMuteNotificationSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
      Source: source,
    });
  },
  onGroupChatSelectMessagesSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.selectMessagesSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatLeaveGroupSelected: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.leaveGroupSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
    });
  },
  onGroupChatSendMessage: (
    attachment, // see enum GROUP_CHAT_ATTACHMENTS
    tags, // see enum GROUP_CHAT_TAGS
    isForwarded,
    isReplied,
    forwardReceiver, // see enum GROUP_CHAT_FORWARD_RECEIVER
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.sendMessage,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      Attachment: attachment,
      Tags: tags,
      'Is Forwarded': isForwarded,
      'Is Replied': isReplied,
      'Forward Receiver': forwardReceiver,
    });
  },
  onGroupChatEditGroupInfoSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.editGroupInfoSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatGiveATipSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.giveATipSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatAddMemberSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.addMemberSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatInviteViaLinkSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.inviteViaLinkSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatUserAvatarMemberSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.userAvatarMemberSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatGroupPhotoSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.chatGroupPhotoSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatEditGroupNameSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.editGroupNameSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatEditDescriptionSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.editDescriptionSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatViewPhotoSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.viewPhotoSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatUploadPhotoSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.uploadPhotoSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatRemovePhotoSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.removePhotoSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatConfirmationRemovePhotoClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.confirmationRemovePhotoClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatConfirmationCancelRemovePhotoClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.confirmationCancelRemovePhotoClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatAddMemberDoneSubmitted: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.addMemberDoneSubmitted,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatTextLinkCopied: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.textLinkCopied,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatSendLinkViaStockbitSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.sendLinkViaStockbitSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatCopyLinkSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.copyLinkSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatShareLinkSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.shareLinkSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatResetLinkSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.resetLinkSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatUserSendInvitationSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.userSendInvitationSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatGroupInvitationSendSubmitted: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.groupInvitationSendSubmitted,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatResetLinkClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.resetLinkClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatCancelResetLinkClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.cancelResetLinkClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatDeleteTheGroupForAllMembersClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.deleteTheGroupForAllMembersClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatLeaveGroupClicked: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.leaveGroupClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
    });
  },
  onGroupChatCancelLeaveGroupClicked: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.cancelLeaveGroupClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
    });
  },
  onGroupChatChooseAdminClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.chooseAdminClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatCancelChooseAdminClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.cancelChooseAdminClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatNewAdminSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.newAdminSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatSetNewAdminAndLeaveGroupSubmitted: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.setNewAdminAndLeaveGroupSubmitted,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatViewUserProfileSelected: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.viewUserProfileSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
    });
  },
  onGroupChatChatUserSelected: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.chatUserSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
    });
  },
  onGroupChatAssignAdminSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.assignAdminSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatRemoveUserFromGroupSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.removeUserFromGroupSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatChooseMemberToGiveATipSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.chooseMemberToGiveATipSelected,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatChooseTip: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    chooseAmount,
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.chooseTip,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
      'Choose amount': chooseAmount,
    });
  },
  onGroupChatTipInputted: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    inputAmount,
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.tipInputted,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
      'Input amount': inputAmount,
    });
  },
  onGroupChatAddMessageTipFilled: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.addMessageTipFilled,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
    });
  },
  onGroupChatSendTipSubmitted: (
    memberType, // see enum GROUP_CHAT_MEMBER_TYPE
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.sendTipSubmitted,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      'Member Type': memberType
        ? GROUP_CHAT_MEMBER_TYPE.admin
        : GROUP_CHAT_MEMBER_TYPE.nonAdmin,
    });
  },
  onGroupChatConfirmAssignAdminClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.confirmAssignAdminClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatCancelAssignAdminClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.cancelAssignAdminClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatRemoveUserClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.removeUserClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatCancelRemoveUserClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.cancelRemoveUserClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatJoinGroupInvitationLinkOpened: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.joinGroupInvitationLinkOpened,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatCancelJoinGroupClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.cancelJoinGroupClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatMessageOpened: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.groupChatMessageOpened,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatRemoveAdminClicked: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.removeAdminClicked,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatCancelRemoveAdmin: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.cancelRemoveAdmin,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatAddAttachment: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.groupChatAddAttachment,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
    });
  },
  onGroupChatAttachmentSelected: (
    action = GROUP_CHAT_INFO_SETTINGS_ACTIONS.groupChatAttachmentSelected,
    attachment,
  ) => {
    clevertapEvent('Group Chat Action', {
      Action: action,
      Attachment: attachment,
    });
  },
};

// for default export
const groupChatAnalytics = {
  createNewGroupChatNavigate,
  groupChatInfoSettings,
  createNewGroupChatAction,
  groupInfoSettingsAction,
};

export default groupChatAnalytics;
